const activity = {
    en: {
        "activity.title": "Activity log",
        "activity.action": "Action",
        "activity.allActions": "All actions",
        "activity.user": "User",
        "activity.role": "Role",
        "activity.entity": "Entity",
        "activity.details": "Details",
        "activity.ip": "IP",
        "activity.date": "Date",
        "activity.from": "From",
        "activity.to": "To",
        "activity.clear": "Clear",
        "activity.none": "No activity recorded",
    },
    ru: {
        "activity.title": "Журнал действий",
        "activity.action": "Действие",
        "activity.allActions": "Все действия",
        "activity.user": "Пользователь",
        "activity.role": "Роль",
        "activity.entity": "Объект",
        "activity.details": "Детали",
        "activity.ip": "IP",
        "activity.date": "Дата",
        "activity.from": "С",
        "activity.to": "По",
        "activity.clear": "Сбросить",
        "activity.none": "Действий не зафиксировано",
    },
    geo: {
        "activity.title": "აქტივობის ჟურნალი",
        "activity.action": "მოქმედება",
        "activity.allActions": "ყველა მოქმედება",
        "activity.user": "მომხმარებელი",
        "activity.role": "როლი",
        "activity.entity": "ობიექტი",
        "activity.details": "დეტალები",
        "activity.ip": "IP",
        "activity.date": "თარიღი",
        "activity.from": "დან",
        "activity.to": "მდე",
        "activity.clear": "გასუფთავება",
        "activity.none": "აქტივობა არ დაფიქსირებულა",
    },
};

export default activity;
